'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment, useCallback, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import H5 from 'UIComponents/elements/headings/H5';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { FormattedMessage } from '../../../components/I18n';
import PracticalExerciseAcademyModal from './PracticalExerciseAcademyModal';
import PracticalExerciseInstructionsCompact from './PracticalExerciseInstructionsCompact';

const PracticalExerciseInstructionsPopover = props => {
  const [isInstructionsOpen, setInstructionsOpen] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);

  const togglePopover = () => {
    setInstructionsOpen(!isInstructionsOpen);
  };

  const setModalOpenMaybeCloseInstructions = useCallback(open => {
    if (isInstructionsOpen) {
      setInstructionsOpen(false);
    }

    setModalOpen(open);
  }, [isInstructionsOpen]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(PracticalExerciseAcademyModal, {
      open: isModalOpen,
      setOpen: setModalOpenMaybeCloseInstructions
    }), /*#__PURE__*/_jsx(UIPopover, {
      autoPlacement: false,
      content: {
        body: /*#__PURE__*/_jsx(PracticalExerciseInstructionsCompact, Object.assign({
          closeInstructions: togglePopover
        }, props))
      },
      open: isInstructionsOpen,
      placement: "bottom",
      width: 400,
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: togglePopover,
        use: "unstyled",
        children: /*#__PURE__*/_jsxs(H5, {
          style: {
            margin: 0
          },
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.instructionsPopOver.instructions"
          }), ' ', /*#__PURE__*/_jsx(UIIcon, {
            name: "down",
            size: "small"
          })]
        })
      })
    })]
  });
};

PracticalExerciseInstructionsPopover.propTypes = {
  description: PropTypes.string,
  isGraded: PropTypes.bool,
  isManuallyApproved: PropTypes.bool,
  name: PropTypes.string
};
export default PracticalExerciseInstructionsPopover;